export class TblUserBidReceipt {
  id?: number;
  submittedBy: string;
  submittedFor: string;
  bidReceipt: string;
  submittedTime: string;

  constructor(
    submittedBy: string,
    submittedFor: string,
    bidReceipt: string,
    submittedTime: string
  ) {
    this.submittedBy = submittedBy;
    this.submittedFor = submittedFor;
    this.bidReceipt = bidReceipt;
    this.submittedTime = submittedTime;
  }
}
